import invariant from 'invariant';
import { sprintf } from 'sprintf-js';

import type { ApiRemoteOptions } from 'api/types/ApiRemoteOptions';
import { getCountryName, getUsStateName } from 'utils/internationalization';

import { getCityStateString } from './getCityStateString';

type Args = {
  remoteOptions: Omit<ApiRemoteOptions, 'locationType'>;
  address: {
    city: string;
    stateCode: string;
    country: string;
  };
};

export const getWorkLocationString = (args: Args) => {
  const {
    remoteOptions: { remoteZone, remoteCountry, remoteState },
    address: { city, stateCode, country },
  } = args;

  if (remoteZone === 'WORLD') {
    return getText('Anywhere');
  }

  if (remoteZone === 'COUNTRY') {
    invariant(remoteCountry, 'Undefined remoteCountry');
    return getCountryName(remoteCountry);
  }

  if (remoteZone === 'STATE') {
    invariant(remoteState, 'Undefined remoteState');
    invariant(remoteCountry, 'Undefined remoteCountry');
    return sprintf(getText('%(state)s, %(country)s'), {
      state: getUsStateName(remoteState),
      country: remoteCountry,
    });
  }

  return getCityStateString({
    city,
    stateCode,
    country,
  });
};
